module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("Get Paid More and Promoted Faster")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "CSS_1.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "d14e48"
    }
  }, [_c('p', {
    staticClass: "center",
    attrs: {
      "id": "d7e343"
    }
  }, [_c('span', [_vm._v("BOOKS BY BRIAN TRACY")])]), _vm._v(" "), _c('p', {
    staticClass: "center",
    attrs: {
      "id": "d7e393"
    }
  }, [_c('span', [_c('i', [_vm._v("Advanced Selling Strategies ")]), _c('br'), _c('i', [_vm._v("Eat That Frog!")]), _c('br'), _c('i', [_vm._v("Effective Leadership ")]), _c('br'), _c('i', [_vm._v("The Gift of Self-Confidence ")]), _c('br'), _c('i', [_vm._v("The Great Big Book of Wisdom ")]), _c('br'), _c('i', [_vm._v("Little Silver Book of Prosperity ")]), _c('br'), _c('i', [_vm._v("Mastering Your Time ")]), _c('br'), _c('i', [_vm._v("Maximum Achievement ")]), _c('br'), _c('i', [_vm._v("The 100 Absolutely Unbreakable Laws ")]), _c('br'), _c('i', [_vm._v("of Business Success ")]), _c('br'), _c('i', [_vm._v("The Peak Performance Woman ")]), _c('br'), _c('i', [_vm._v("Personal Achievement ")]), _c('br'), _c('i', [_vm._v("Success Is a Journey ")]), _c('br'), _c('i', [_vm._v("Successful Selling ")]), _c('br'), _c('i', [_vm._v("A Treasury of Personal Achievement ")]), _c('br'), _c('i', [_vm._v("The 21 Success Secrets of Self-Made Millionaires ")]), _c('br'), _c('i', [_vm._v("Universal Laws of Success ")]), _c('br'), _c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "center",
    attrs: {
      "id": "d7e973"
    }
  }, [_c('span', [_vm._v("COAUTHORED BY BRIAN TRACY ")])]), _vm._v(" "), _c('p', {
    staticClass: "center",
    attrs: {
      "id": "d7e1023"
    }
  }, [_c('span', [_c('i', [_vm._v("Speaking Secrets of the Masters ")]), _c('br'), _c('i', [_vm._v("Insights into Excellence ")]), _c('br'), _c('i', [_vm._v("Traits of Champions ")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4c6815e8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Chapter.vue
// module id = 60
// module chunks = 0